// @ts-nocheck
import { STORE_PREFIX } from './constants';
import { initialState } from './reducer';

const skuExclusionSelector = (state) => state[STORE_PREFIX] || initialState;
//open modal
export const getOpenModalName = (state) => {
	return skuExclusionSelector(state)['openModalName'];
};

export const getLoadingStatus = (state) => {
	return skuExclusionSelector(state)['loading'];
};
